import { Box } from '@mui/material';

import ScheduleBlock from './ScheduleBlock';
import { WEEKLY_SCHEDULE_DAY_COLUMN_SX } from '../styles';

import type { ScheduleDayColumnProps } from '../types';

export default function ScheduleDayColumn({ items, onDelete }: ScheduleDayColumnProps) {
  const startOffsets = new Set(items.map((item) => item.startHourOffset));

  return (
    <Box sx={WEEKLY_SCHEDULE_DAY_COLUMN_SX}>
      {items.map((item) => (
        <ScheduleBlock
          key={item.id}
          item={item}
          onDelete={onDelete}
          showBottomDivider={startOffsets.has(item.startHourOffset + item.durationHours)}
        />
      ))}
    </Box>
  );
}
